import { NgModule } from '@angular/core';
import { RecaptchaModule } from 'ng-recaptcha';
import { SignUpBoxModule } from '../components/sign-up-box/sign-up-box.component';
import { HeaderModule } from '../header/header.module';
import { SharedModule } from '../shared/shared.module';
import { CookieNoticeComponent } from './cookie-notice/cookie-notice.component';
import { LoginBoxComponent } from './login-box/login-box.component';
import { LoginPageComponent } from './login-page/login-page.component';
import { LoginService } from './login.service';
import { PasswordSetupBoxComponent } from './password-setup-box/password-setup-box.component';
import { PasswordSetupPageComponent } from './password-setup-page/password-setup-page.component';
import { RecoveryBoxComponent } from './recovery-box/recovery-box.component';
import { RecoveryPageComponent } from './recovery-page/recovery-page.component';
import { SharedAccountDialogComponent } from './shared-account-dialog/shared-account-dialog.component';

@NgModule({
  declarations: [
    LoginPageComponent,
    LoginBoxComponent,
    RecoveryPageComponent,
    RecoveryBoxComponent,
    CookieNoticeComponent,
    PasswordSetupPageComponent,
    PasswordSetupBoxComponent,
    SharedAccountDialogComponent,
  ],
  entryComponents: [SharedAccountDialogComponent],
  imports: [SharedModule, RecaptchaModule.forRoot(), SignUpBoxModule, HeaderModule],
  providers: [LoginService],
})
export class LoginModule {}



// WEBPACK FOOTER //
// ./ts/app/login/login.module.ts